import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'
import { fetchData } from '../../shared/api/api'
import { Id } from '../../shared/types'
import { ScriptDataResponse } from './types'

export const fetchUserScripts = createAsyncThunk<
  ScriptDataResponse,
  void,
  { state: RootState }
>('script/fetchUserScripts', async (_, thunkAPI) => {
  const state = thunkAPI.getState()
  const { user, zone } = state

  const userId = user?.profile?.uid
  const zoneId = zone?.data?.id

  if (!userId || !zoneId) {
    return thunkAPI.rejectWithValue('Missing userId or zoneId from state.')
  }

  try {
    const response = await fetchData<ScriptDataResponse>(
      `/users/${userId}/dossiers/${zoneId}/script`
    )

    return {
      script: response?.script || [],
      completion: response?.completion ?? null,
    }
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error || error.message || 'Unknown error'
    )
  }
})
